module.exports = __webpack_public_path__ + "img/b30adebd9e1f90aacd6609137458a03c.svg";